module.exports = __webpack_public_path__ + "img/sld_scb_9_t1_red.7aa4d8d6.svg";